import { createContext } from 'react';
import type { IBettingConfigCtx } from 'types';

// NOTE: BettingConfigCtx should not have default value
export const BettingConfigCtx = createContext<IBettingConfigCtx>(
    {} as IBettingConfigCtx
);
